"use strict";

exports.__esModule = true;
exports.wrapPageElement = void 0;
var _wrapPage = require("./wrap-page");
exports.wrapPageElement = _wrapPage.wrapPageElement;